module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__markup-yellow",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('nav-switcher', {
    staticClass: "block",
    attrs: {
      "items": _vm.switcher,
      "styleParams": _vm.styleParams
    }
  }), _c('form-filter', {
    staticClass: "block",
    attrs: {
      "action": _vm.filterAction,
      "fields": _vm.list,
      "button-text": _vm.buttonText,
      "styleParams": _vm.styleParams
    },
    on: {
      "change": _vm.change,
      "submit": _vm.submit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d53c2ea","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/filter/Yellow.vue
// module id = d54059a9bb12437ac5d3
// module chunks = 0